import storage from 'proxy-storage';
import getHCStorage from './getHCStorage';

/**
 * @public
 * Stores the phone object in the `hc` storage
 *
 * @param  {Object} phone - object with the phone data
 * @return {Object}
 */
export default function storePhoneNumber(phone) {
  if (phone && phone.data && phone.data.promo_number) {
    const hcStorage = getHCStorage();
    hcStorage.invoca_phone = phone.data;
    hcStorage.invoca_phone.source = hcStorage.source;
    storage.setItem('hc', hcStorage);
  }
  return phone.data || null;
}
